import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";
import Footer from 'components/Footer/Footer';
import './style.css';
import StaticBanner from 'components/Banner/StaticBanner';
//import StoryTeller from 'components/StoryTeller/StoryTeller';
import Button from 'components/Button/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import eventBanner from "Assets/eventPresentation.png";
//import business from 'Assets/hostimg.png';
//import presentation from "Assets/presentation.png";
//import Record from "Assets/record.png";
// import Sponsor from "components/Sponsors/Sponsor";
// import kohler from "Assets/kohlerlogo.svg";
// import lego from "Assets/legol.svg";
// import dentsu from "Assets/dentsulogo.svg";
// import vmware from "Assets/vmwarelogo.svg";
import eventBanner from "Assets/internationalpk/ipk2020_landing_page_banner.jpeg";
//import childrenImg from "Assets/internationalpk/children-school-desk.jpg";
import childrenImg from "Assets/internationalpk/people_laptop.jpg";
import storytellingMadeEasyImg from "Assets/internationalpk/Safari_PSD_Mockup.png";
//import ipkLogosImg from "Assets/internationalpk/ipk_logos.png";
import inspirationImg from "Assets/internationalpk/inspiration.jpg";

import { ReactTypeformEmbed } from 'react-typeform-embed';
import home from 'Assets/home.svg';
export default class InternationalPk extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        
        return (
            <React.Fragment>
                <Helmet>
                    <title>International PechaKucha Day - February 20, 2020</title>
                    <meta name="description" content="One Day, Hundreds of Events, Thousands of PechaKucha Presentations" />
                    <meta property="og:image" content={`https://www.pechakucha.com${eventBanner}`} />
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content="https://www.pechakucha.com/internationalpk" />
                    <meta property="og:title" content="International PechaKucha Day - February 20, 2020" />
                    <meta property="og:description" content="One Day, Hundreds of Events, Thousands of PechaKucha Presentations" />
                </Helmet>
                <div>
                    {/* Banner Starts */}
                    <div>
                        <NavLink to="/channels/international_pechaKucha_day">
                        <section className="bannerimg-head" style={{ backgroundImage: `url( ${eventBanner})` }}>
                            <div className="container">
                            </div>
                        </section>
                        </NavLink>
                    </div>
                    {/*
                    <StaticBanner
                        bannerImg={eventBanner}
                        internationalDay=""
                        internationalEvents=""
                        internationalPresentations=""
                        btnStatus={false}
                        bannerFullWidth={true}
                    />
                    */}
                
                    {/* Banner Section ends */}
                    {/* Description Section Starts */}
                    {/*
                    <div className="container">
                        <div className="aboutInternationalDay">
                            <h3>20th February 2020 marks our first annual International PechaKucha Day. We invite our entire PechaKucha community to celebrate and create as many PK events and presentations as possible!.
                            </h3>
                        </div>
                    </div>
                    */}
                    <div className="container">
                        <div style={{ fontFamily: "Open Sans,sans-serif" }} className="aboutInternationalDay">
                            {/* <p dangerouslySetInnerHTML={{ __html: danger1 }} /> */}
                            <h1 className="null">International PechaKucha Day!&nbsp;</h1>
                            <strong>Find all of the events happening&nbsp;
                            <NavLink to="/channels/international_pechaKucha_day">here</NavLink>!
                            </strong>
                            <br />
                            February 20th, 2020 marks our first annual <strong>International PechaKucha Day</strong>. We invite our entire PechaKucha community to celebrate and create as many PK events and presentations as possible!
                            
                            <p dir="ltr">How can you celebrate International PechaKucha Day with us?</p>
                            
                            <p dir="ltr">Here are a few ideas:</p>
                            
                            <ul dir="ltr">
                            	<li>Hold or attend a regular PechaKucha Night (on Feb 20!)</li>
                            	<li>Organize a PechaKucha event in a local school!</li>
                            	<li>Host a PechaKucha event in your office!</li>
                            	<li>Organize a PechaKucha event in your local city offices!</li>
                            	<li>Create a PechaKucha presentation right here: <a href="https://www.pechakucha.com/pkcreate">PechaKucha.com/PKCreate</a>!</li>
                            	<li>Tag and share all your International PechaKucha Day contents with the hashtag: #ipk2020</li>
                            </ul>
                            
                            <p dir="ltr">Sign up and let us know what you are planning to organize and get your event listed on PechaKucha.com</p>
                            
                            <center>
                            <a rel="noopener noreferrer" target='_blank' href="https://pechakucha.typeform.com/to/A3GKdD">
                                <Button theme="btn-getstarted btn-hover btn-green btn-fit btn-none">
                                    Join Us for International PechaKucha Day!
                                </Button>                            
                            </a>
                            </center>
                            
                            <hr/>
                            
                            <StaticBanner
                                bannerImg={childrenImg}
                                internationalDay="Get the Word Out!"
                                internationalEvents="PechaKucha at School and Offices"
                                internationalPresentations="Mission #ipk2020!!"
                                btnStatus={false}
                                bannerHeight="300px"
                            />
                            <br/>

                            <p dir="ltr">
                                PechaKucha is being used by thousands of schools and businesses around the world.
                                Teachers use PechaKucha as an education tool. Students use PK for presentations. Researchers use PK to simply explain academic findings.
                                Businesses use concise PechaKucha presentations for internal updates, employee on-boarding, and sales pitches.
                            </p>
                            
                            <center>
                            <a rel="noopener noreferrer" target="_blank" href="https://pechakucha.typeform.com/to/A3GKdD">
                                <Button theme="btn-getstarted btn-hover btn-green btn-fit btn-none">
                                    Host an Event at Your Business or School!
                                </Button>
                            </a>
                            </center>
                            <br/>
                            <hr/>
                            
                            <StaticBanner
                                bannerImg={storytellingMadeEasyImg}
                                internationalDay="Create a 20x20 Presentation"
                                internationalEvents=" on PechaKucha.com"
                                internationalPresentations="It's easy!"
                                btnStatus={false}
                                bannerHeight="400px"
                            />
                            <br/>

                            <p dir="ltr">
                            1. Collect 20 great images<br />
                            2. Upload them into a new presentation on PechaKucha.com<br />
                            3. Record your voice as the slides advance<br />
                            4. Publish and Share and <strong>tag with #ipk2020</strong> !<br />
                            5. Congrats! You&#39;ve celebrated with the International PechaKucha Day with us!</p>

                            <center>
                            <NavLink target="_blank" to="/pkcreate" >
                                <Button theme="btn-getstarted btn-hover btn-green btn-fit btn-none">
                                    Create a Presentation on PechaKucha.com!!
                                </Button>
                            </NavLink>    
                            </center>
                            <hr/>
                            
                            <StaticBanner
                                bannerImg={inspirationImg}
                                internationalDay="Need More Inspiration?"
                                internationalEvents="Get to Know the PK Team!"
                                internationalPresentations=""
                                btnStatus={false}
                                bannerHeight="400px"
                            />
                            <br/>
    
                            <p dir="ltr">&bull; In Tokyo, we&#39;ll be hosting a morning PechaKucha session at the office to get the creative energy flowing for the day!</p>
                            
                            <p dir="ltr">&bull; At lunchtime we&#39;re teaming up with with a local organization to co-host a PechaKucha session for their members!</p>
                            
                            <p dir="ltr">&bull; In the afternoon we&#39;re hosting a short workshop for our community on how to create a PK Presentation on pechakucha.com!</p>
                            <p dir="ltr">&bull; In the evening, it&#39;s PechaKucha Night!!! WOOHOO!</p>

                            <center>
                            <a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/events/672918699779340/">
                                <Button theme="btn-getstarted btn-hover btn-green btn-fit btn-none">
                                    Let's Inspire Each Other!
                                </Button>
                            </a>
                            </center>
                        </div>
                    </div>

                    {/* Way to Participate Section Ends */}
                    <hr/>
                    {/* Form Section */}
                    <section id="getMoreInfoData" className="p-t0">
                        <div className="container">
                            <Row>
                                <Col lg={12}>
                                    <div className="form-head">
                                        <h1>Join the movement. Be a part of the PechaKucha community!</h1>
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div>
                                        <div className="school-formdetails">
                                            <ReactTypeformEmbed style={{height: "500px"}} url="https://pechakucha.typeform.com/to/A3GKdD" />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </section>
                    {/* Form Section Ends */}
    
                    <Footer
                        homeImg={home}
                        homeImgRef="/"
                        breadcrumbSubPage="International Pk" />
                </div>
            </React.Fragment>
        );
    }
}
